import i18n from '@/i18n'

const fields = () => {
  return [
    {
      key: 'label',
      label: i18n.t('setting.list.development.tokenName'),
      isEditable: true,
      name: 'label',
      placeholder: 'Masukkan nama token',
      type: 'text',
      validation: 'required',
      thClass: 'w-25',
    },
    {
      key: 'access_token',
      label: i18n.t('setting.homePage.tokenApi'),
      thClass: 'w-25',
      tdAttr: {
        style: 'max-width:100%;',
      },
    },
    {
      key: 'created',
      label: i18n.t('setting.list.development.createdDate'),
    },
    {
      key: 'revoke_action',
      label: i18n.t('setting.list.development.action'),
      thClass: 'revoke-action-header w-25',
    },
  ]
}

export default fields
